import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDividerModule} from '@angular/material/divider';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import {MatTooltipModule} from '@angular/material/tooltip';

import { UpdateEmployeesComponent } from './update-employees.component';
import { BdColaboradoresComponent } from './bd-colaboradores/bd-colaboradores.component';
import { DescargarPlantillaComponent } from './descargar-plantilla/descargar-plantilla.component';

@NgModule({
  declarations: [
    UpdateEmployeesComponent,
    BdColaboradoresComponent,
    DescargarPlantillaComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatStepperModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatListModule,
    MatTooltipModule
  ]
})
export class UpdateEmployeesModule { }
